import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';
import {
  Container,
  Button,
  Row
} from 'reactstrap';
import classNames from 'classnames';

import { getTopSellingProduct, getDetailSection, sortingSearchResultAPI } from '../../actions/productAction';
import { Banner, Content } from '../Assets';
import CardLoading from '../../components/Loading/CardLoading';
import FilterAndSort from '../../components/PageSearchDetails/FilterAndSort';
import { isFromAppBrowser, getCloudImageUrl } from '../../utils/Helpers';
import SneakerLoadingSpinner from '../../components/Sneakers/SneakerLoadingSpinner';
import Sneaker from '../../components/Sneakers/Sneaker';

import { ASSET_IMAGE, RESOURCE_URL } from '../../config'

class BestSelling extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      page: 1,
      prevY: 0,
      loading: true,
      hasMore: true
    }
  }

  componentDidMount() {
    const { dataCategory } = this.props;
    let paramCheck = this.props.location.pathname.includes("most-popular")
    let section = paramCheck ? "trending-now" : "top-selling"

    this.props.getDetailSection(dataCategory, section)

    let options = {
      root: null, 
      rootMargin: '0px',
      threshold: 0.7
    };
    const isInfiniteScrolL = !isFromAppBrowser();
    this.setState({ isInfiniteScrolL })
    this.getProductList();
    if(isInfiniteScrolL) {
      // Create an observer instance
      this.observer = new IntersectionObserver(
        this.handleObserver.bind(this), // pass the callback
        options
      );
      this.observer.observe(this.loadingRef);
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    if(prevProps.dataTopSelling.isFetching && !this.props.dataTopSelling.isFetching){
      const { pagination, hasMoreData } = this.props.dataTopSelling;
      this.setState({
        hasMore: hasMoreData !== null,
        loading: false
      })
    }
    if(prevProps.dataCategory !== this.props.dataCategory){
      const { dataCategory } = this.props;
      await this.setState({ page: 1, loading: true, hasMore: true, prevY: 0 });
      this.getProductList();
    }
  }

  getProductList = () => {
    const { dataCategory } = this.props;
    const { page } = this.state;
    const payload = {
      params: {
        category: dataCategory,
        per_page: 20,
        page,
        range_value: 50
      }
    }

    let paramCheck = this.props.location.pathname.includes("most-popular")
    let categoryUrl = this.props.location.pathname.includes("local-brands") ? "madeindonesia" : dataCategory

    this.setState({ loading: true });

    if(paramCheck){
      this.props.sortingSearchResultAPI('', {
        params: {
          category: categoryUrl,
          sort_by: 'most_popular',
          page,
          availables: true,
        },
      })
    } else {
      this.props.getTopSellingProduct(payload)
    }
    this.setState({ loading: false, page: page + 1 })
    this.setState({ loading: false })
  }
  
  _handleNextPageClick = async () => {
    if(!this.state.loading && this.state.hasMore){
      this.getProductList();
    }
  }

  async handleObserver(entities, observer) {
    const { dataCategory } = this.props;
    const { data, isFetching, pagination } = this.props.dataTopSelling;

    const y = entities[0].boundingClientRect.y;
    if (this.state.hasMore && !isFetching) {
      if (this.state.prevY > y) {
        this.getProductList();
      }
      this.setState({ prevY: y });
    }
  }

  renderProducts() {
    // const isUnreleased = this.props.statusPage === 'unreleased' ? false : true;
    const {dataTrendingNow} = this.props
    const { data, isFetching } = this.props.dataTopSelling;
    const paramCheck = this.props.location.pathname.includes("most-popular")
    
    if (isFetching && (data && data.length === 0)) {
      return <CardLoading />
    } else if ((paramCheck && dataTrendingNow.length <= 0) || (!paramCheck && data.length <= 0)) {
      return (
        <Container className="page-container" style={{minHeight:500, display:'flex',alignItems:'center',flexDirection:'row'}}>
          <div style={{flex:1}}>
              <div style={{width:200,margin:" 0px auto"}}>
                  <h3 className="text-center">Mohon Maaf!</h3>
                  <h5 className="text-center">Sneaker tidak ditemukan. Hubungi kami di Whatsapp untuk request produk baru.</h5>
              </div>
          </div>
        </Container>
      )
    } else {
      if(paramCheck){
        return dataTrendingNow.map((item, index) => {
          return <Sneaker 
            {...item} 
            hotProducts={this.props.hotProducts} 
            category={this.props.dataCategory} 
            key={index} 
            // outOfStock={isUnreleased} 
            statusPage={this.props.statusPage}
          />
        })
      } else {
        return data.map((item, index) => (
          <Sneaker 
            {...item} 
            hotProducts={this.props.hotProducts} 
            category={this.props.dataCategory} 
            key={index} 
            // outOfStock={isUnreleased} 
            statusPage={this.props.statusPage}
          />
        ))
      }
    }
  }

  renderList() {
    return (
      <div id="product">
        <Row style={{ minHeight:500, display:'flex',alignItems:'flex-start', flexDirection:'row'}}>
          { this.renderProducts() }
        </Row>
      </div>
    )
  }

  render() {
    const { dataSection } = this.props;
    const { isFetching, hasMoreData } = this.props.dataTopSelling;
    const landscapeImage = dataSection.data &&  dataSection.data.images && dataSection.data.images.length > 0 ? dataSection.data.images.find((i) => i.orientation === "landscape") : null;
    const portraitImage = dataSection.data &&  dataSection.data.images && dataSection.data.images.length > 0 ? dataSection.data.images.find((i) => i.orientation === "portrait") : null;
    const imageBanner = landscapeImage ? landscapeImage.URL : null;
    const mobileBanner = portraitImage ? portraitImage.URL : null;
    
    return (
      <Container fluid className="main-container" id="home-container">
        <div className="d-none d-sm-block">
          <Banner
            src={getCloudImageUrl(imageBanner, 1500, "top-selling")}
            alt={imageBanner}
          />
        </div>
        <div className="d-block d-sm-none">
          <Banner 
            src={getCloudImageUrl(mobileBanner, 1500, "top-selling")}
            alt={mobileBanner}
          />
        </div>
        <div className="product-list">
          { this.renderList() }
          {
            !this.state.isInfiniteScrolL?
              <div className="d-flex justify-content-center">
                <Button
                  block
                  size={"lg"}
                  type="button"
                  onClick={this._handleNextPageClick}
                  className={classNames('button-load-more browse__all',{'d-none': this.state.loading || !this.state.hasMore})}
                >
                  Load More
                </Button>
              </div>
            :null
          }
          <SneakerLoadingSpinner
            isLoading={this.state.loading && this.state.page > 1}
            isHide={!this.state.hasMore}
            wrapperRef={loadingRef => this.loadingRef = loadingRef}
          />
        </div>
        
      </Container>
    )
  }
}

const mapStateToProps = state => ({
  dataSection: state.dataProduct.dataSection,
  dataTopSelling: state.dataProduct.topSelling,
  dataCategory: state.dataCategory.selected,
  dataTrendingNow: state.dataProduct.searchResult
})

const mapDispatchToProps = dispatch => ({
  getDetailSection: (category, type) => dispatch(getDetailSection(category, type)),
  getTopSellingProduct: (params) => dispatch(getTopSellingProduct(params)),
  sortingSearchResultAPI: (
    paramsRoute,
    caseSort,
    status_action,
  ) => dispatch(sortingSearchResultAPI(paramsRoute, caseSort, status_action)),
})

export default connect(mapStateToProps, mapDispatchToProps)(BestSelling);
